var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckCircleBroken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 89,
    viewBox: "0 0 88 89",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "check-circle-broken"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M80.6666 41.306V44.6794C80.6621 52.5862 78.1018 60.2798 73.3675 66.6127C68.6332 72.9456 61.9786 77.5784 54.3962 79.8203C46.8138 82.0622 38.7099 81.793 31.293 79.0528C23.8761 76.3127 17.5437 71.2484 13.2401 64.6153C8.93656 57.9822 6.89249 50.1356 7.41273 42.2458C7.93298 34.3561 10.9897 26.8459 16.1269 20.8353C21.2642 14.8247 28.2068 10.6358 35.9193 8.89322C43.6318 7.15069 51.7009 7.94792 58.9233 11.166M80.6666 15.325L43.9999 52.0284L32.9999 41.0284",
    stroke: "white",
    strokeWidth: 2.44444,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckCircleBroken);
export default __webpack_public_path__ + "static/media/check-circle-broken.9cd07b17cf691e733ab009d0de2e3c0e.svg";
export { ForwardRef as ReactComponent };